/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Spreadsheet from 'react-spreadsheet';
import { isNullOrBlank } from '../../../utils/checker';
import { calculateORDCells } from '../../../utils/ews-ord-utils';
import { toFormatCurrency } from '../../../utils/format';
import { checkSelectedActiveColumn } from '../../../utils/market-development';
import { makeBoldCells } from '../utils';
import EWSLabels from './ews-template-labels';

export default function EWSORD({ readOnly = false, code = null, labels = [], cells = [], onChange = ({ code, cells }) => null }) {
	const { t } = useTranslation();
	const [dataCells, setDataCells] = useState([]);
	const [active, setActive] = useState(null);

	useEffect(() => {
		setDataCells(
			makeBoldCells(
				labels,
				cells.map((row, rowIndex) =>
					row.map((cell, colIndex) => ({
						...cell,
						value: (function () {
							if (false === isNullOrBlank(cell?.value)) {
								if (colIndex === 0) {
									return toFormatCurrency(cell.value);
								} else if (colIndex === 1) {
									return toFormatCurrency(cell.value, null);
								}
							}
							return cell?.value;
						})(),
					})),
				),
			),
		);
	}, [cells]);

	return (
		<>
			<Box>
				<Text fontSize="large" fontWeight="bold" mb={4}>
					{t('Other Required Disclosures')}
				</Text>
				<Box className="ews-container">
					<div className="ews-1-row-head" />
					<table className="spreadsheet_custom_header">
						<thead>
							<tr style={{ height: '34px' }}>
								<td className={checkSelectedActiveColumn(active, 0) ? 'active-column' : 'ews-background-light-silver'}>{t('USD')}</td>
								<td className={checkSelectedActiveColumn(active, 1) ? 'active-column' : 'ews-background-light-silver'}>{t(`KHR'000`)}</td>
							</tr>
						</thead>
					</table>
					<div>
						<EWSLabels type="EWS" labels={labels} active={active} />
						<Box>
							<Flex alignItems="center" mt="0px" h="0px" borderRight="1px solid hsl(2deg, 0%, 91%)" pl={2} pr={2} />
							<Spreadsheet
								data={dataCells}
								onChange={(dataCells) => {
									if (readOnly) {
										onChange({
											code,
											cells: cells?.reduce((pre, cur, i) => {
												let localPre = pre;
												localPre.push([
													{ value: cur[0]?.value, readOnly: true },
													{ value: cur[1]?.value, readOnly: true },
												]);
												return localPre;
											}, []),
										});
									} else {
										onChange(calculateORDCells({ code, cells: dataCells, numLabel: labels?.length }));
									}
								}}
								onActivate={(e) => setActive({ ...e, t: 'EWS' })}
								hideRowIndicators
								hideColumnIndicators
							/>
						</Box>
					</div>
				</Box>
			</Box>
		</>
	);
}
